import { put, call } from 'redux-saga/effects';
import { actions as toastrActions } from 'react-redux-toastr';

import { clientesAPI } from 'services/apiRest';
import ClientesActions from '../ducks/clientes';

export function* getClientes() {
  try {
    const clientes = yield call(clientesAPI.listar);
    yield put(ClientesActions.getClientesSuccess(clientes));
  } catch (err) {
    console.error('Erro ao buscar clientes:', err);
    yield put(ClientesActions.getClientesFailure(err));
    yield put(
      toastrActions.add({
        type: 'error',
        title: 'Erro',
        message: 'Erro ao buscar clientes',
      })
    );
  }
}

export function* addCliente({ cliente, closeModal }) {
  try {
    const clienteCriado = yield call(clientesAPI.criar, cliente);
    yield put(ClientesActions.addClienteSuccess(clienteCriado));
    
    if (closeModal) closeModal();
    
    yield put(
      toastrActions.add({
        type: 'success',
        title: 'Cliente',
        message: 'Cliente criado com sucesso!',
      })
    );
  } catch (err) {
    console.error('Erro ao criar cliente:', err);
    yield put(ClientesActions.addClienteFailure(err));
    yield put(
      toastrActions.add({
        type: 'error',
        title: 'Erro',
        message: 'Erro ao criar cliente',
      })
    );
  }
}

export function* updateCliente({ cliente, closeModal }) {
  try {
    const clienteAtualizado = yield call(
      clientesAPI.atualizar,
      cliente.id,
      cliente
    );
    yield put(ClientesActions.updateClienteSuccess(clienteAtualizado));
    
    if (closeModal) closeModal();
    
    yield put(
      toastrActions.add({
        type: 'success',
        title: 'Cliente',
        message: 'Cliente atualizado com sucesso!',
      })
    );
  } catch (err) {
    console.error('Erro ao atualizar cliente:', err);
    yield put(ClientesActions.updateClienteFailure(err));
    yield put(
      toastrActions.add({
        type: 'error',
        title: 'Erro',
        message: 'Erro ao atualizar cliente',
      })
    );
  }
}

export function* removeCliente({ id }) {
  try {
    yield call(clientesAPI.deletar, id);
    yield put(ClientesActions.removeClienteSuccess(id));
    
    yield put(
      toastrActions.add({
        type: 'success',
        title: 'Cliente',
        message: 'Cliente excluído com sucesso!',
      })
    );
  } catch (err) {
    console.error('Erro ao excluir cliente:', err);
    yield put(ClientesActions.removeClienteFailure(err));
    yield put(
      toastrActions.add({
        type: 'error',
        title: 'Erro',
        message: 'Erro ao excluir cliente',
      })
    );
  }
}

